/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom';
import { colors } from '@chegg-ui/theme';
import { OrderConfirmationIframe } from './components/OrderConfirmationIframe';
var addIframe = function addIframe(container, props) {
  if (props !== null && props !== void 0 && props.productFamily) {
    ReactDOM.render( /*#__PURE__*/React.createElement(OrderConfirmationIframe, props), container);
  } else {
    ReactDOM.render( /*#__PURE__*/React.createElement("p", {
      style: {
        color: "".concat(colors.errorRed)
      }
    }, "Please pass in required props"), container);
  }
};
export { OrderConfirmationIframe, addIframe };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/order-confirmation/dist/esm/index.js
// module id = 4195
// module chunks = 11